export const FLASHCARDS_EDITOR_CLASSNAME = "editFlashcardTextAreaInput";
